import {rePostionContents, reSizeBackground} from "./cavasResize";
import {gsap} from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin";

gsap.registerPlugin(PixiPlugin);


promokit.preload({
    complete: function() {
        $('.p-flag').remove();
    }
});




let opts = {
    w: $(window).width(),
    h: $(window).height(),
    sec2W: $('.p-sec2').width(),
    sec2H: $('.p-sec2').height(),
}



// canvas init
let leftCanvas = {};
leftCanvas.app = new PIXI.Application({ width: opts.w, height: opts.h, transparent: true});
$('.p-sec1__inner').append(leftCanvas.app.view);

leftCanvas.filters = {};
leftCanvas.filters.zoomBlurFilter = new PIXI.filters.ZoomBlurFilter();
leftCanvas.filters.zoomBlurFilter.center = [opts.w/2, opts.h/2];
leftCanvas.filters.zoomBlurFilter.innerRadius = 0;

// BG append
leftCanvas.bg = new PIXI.Sprite.fromImage(`${promokit.store('staticPath')}/promo/aion/event/2020/201021_index/img/sec1-bg.jpg`);
// leftCanvas.bg.filters = [leftCanvas.filters.zoomBlurFilter];
leftCanvas.app.stage.addChild(leftCanvas.bg);

// container append
leftCanvas.con = new PIXI.Container();
leftCanvas.con.x = opts.w/2 - 1920/2;
leftCanvas.con.y = 0;
leftCanvas.app.stage.addChild(leftCanvas.con);

// left character append
/*leftCanvas.characterLeft = new PIXI.Sprite.fromImage('https://op-wstatic.ncsoft.com/promo/aion/event/2020/201021_index/img/left.png');
leftCanvas.characterLeft.x = 190;
leftCanvas.characterLeft.y = 100;
leftCanvas.con.addChild(leftCanvas.characterLeft);*/

// right character append
/*leftCanvas.characterRight = new PIXI.Sprite.fromImage('https://op-wstatic.ncsoft.com/promo/aion/event/2020/201021_index/img/right.png');
leftCanvas.characterRight.x = 870;
leftCanvas.characterRight.y = -130;
leftCanvas.con.addChild(leftCanvas.characterRight);*/

// title append
leftCanvas.title = new PIXI.Sprite.fromImage(`${promokit.store('staticPath')}/promo/aion/event/2020/201021_index/img/sec1-title.png`);
leftCanvas.title.x = 727;
leftCanvas.title.y = 275;
leftCanvas.con.addChild(leftCanvas.title);

let rightCanvas = {};
rightCanvas.app = new PIXI.Application({ width: opts.sec2W, height: opts.sec2H, transparent: true});
$('.p-sec2__inner').append(rightCanvas.app.view);

// container append
rightCanvas.con = new PIXI.Container();
rightCanvas.con.x = opts.w/2 - 1920/2;
rightCanvas.con.y = 0;
rightCanvas.app.stage.addChild(rightCanvas.con);

// title append
rightCanvas.title = new PIXI.Sprite.fromImage(`${promokit.store('staticPath')}/promo/aion/event/2020/201021_index/img/sec3-title.png`);
rightCanvas.title.x = 645;
rightCanvas.title.y = 279;
rightCanvas.con.addChild(rightCanvas.title);




$(document).on({
    'mouseenter': function(){
        $('.p-sec1__btn').addClass('active');
        gsap.to('.p-sec1__char1', { x: 3, opacity: 0.7, duration: 1.5, ease: 'power2.out'})
        gsap.to('.p-sec1__char2', { x: -3, opacity: 0.7, duration: 1.5, ease: 'power2.out'})
        gsap.to(leftCanvas.title, { pixi: { contrast: 1.8 }, duration: 1 })
        gsap.fromTo('.p-sec1 .effect-btn__item', { scale: 0.9, opacity: 1 }, { scale: 1.2, opacity: 0, stagger: function(index, target, list) {
                return index * 0.55;
            }, duration: 2})
    },
    'mouseleave': function(){
        $('.p-sec1__btn').removeClass('active');
        gsap.to('.p-sec1__char1', { x: 0, opacity: 1, duration: 1})
        gsap.to('.p-sec1__char2', { x: 0, opacity: 1, duration: 1})
        gsap.to(leftCanvas.title, { pixi: { contrast: 1 }, duration: 1 })
    }
}, '.p-sec1__inner')

$(document).on({
    'mouseenter': function(){
        $('.p-sec2__btn').addClass('active');
        // gsap.to('.p-sec2__char1', { x: 3, opacity: 0.7, duration: 1.5})
        gsap.to(rightCanvas.title, { pixi: { contrast: 2 }, duration: 1 })
        gsap.fromTo('.p-sec2 .effect-btn__item', { scale: 0.9, opacity: 1 }, { scale: 1.2, opacity: 0, stagger: function(index, target, list) {
                return index * 0.55;
            }, duration: 2})
    },
    'mouseleave': function(){
        $('.p-sec2__btn').removeClass('active');
        // gsap.to('.p-sec2__char1', { x: 0, opacity: 1, duration: 1})
        gsap.to(rightCanvas.title, { pixi: { contrast: 1 }, duration: 1 })
    }
}, '.p-sec2__inner')



$(window).on('resize', function(){
    let opts = {
        w: $(window).width(),
        h: $(window).height(),
        sec2W: $('.p-sec2').width(),
        sec2H: $('.p-sec2').height(),

    }

    if( opts.w >= 1100 ){
        reSizeBackground(leftCanvas.bg, opts.w, opts.h);
        rePostionContents(leftCanvas.con, opts.w, opts.h, 1920, 1080, true);
        rePostionContents(rightCanvas.con, opts.sec2W, opts.sec2H, 1920, 1080, true);
        leftCanvas.app.renderer.resize(opts.w, opts.h);
        rightCanvas.app.renderer.resize(opts.sec2W, opts.sec2H);
    }
});








var page = promokit.page({
    caution: false,
    cnb: true, //true, false
    topButton: false, //true, false
    footer: false,
    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'year', //'year', 'week', 'day'
            key: 'INDEX_WEB_VISIT_201028_index',
            value: false
        },
        home: true,
        event: true,
        update: false,
        sns: true,
        theme: 'white' //'black', 'white'
    },
    remote: false,
});


// WEBPACK FOOTER //
// ./src/js/index.js